"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fireflyProps = {
    EXPIRATION_DAYS: 30,
    IA_SESSION_STORAGE: 'ffIASession',
    PERSISTENT_STORE: 'ffpersistent',
    RADIX_DECIMAL: 10,
    SESSION_STORE: 'ffsession',
    VID_EXPIRATION_DAYS: 720,
    VISITOR_ID: 'visitorId'
};
exports.default = fireflyProps;
